(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		define('storeService', ['repositoryService', 'statusService'], function (repositoryService, userService) {
			return factory(root, repositoryService, userService);
		});
	} else {
		root.StoreService = factory(root, repositoryService, userService);
	}
})(this, function (root, repositoryService, userService) {

	/**
	 * @constant
	 * @type {String}
	 */
	var storeStorageKey = 'THD_LOCSTORE';

	/**
	 * @member
	 * @description Default store #121 details
	 * @type {object}
	 */
	var defaultStore = {
		storeId: '121',
		name: 'Cumberland',
		address: {
			postalCode: '30339',
			county: 'Cobb',
			state: 'GA',
			country: 'US',
			city: 'Atlanta',
			street: '2450 Cumberland Pkwy'
		},
		storeHours: {
			monday: {
				open: '6:00',
				close: '21:00'
			},
			tuesday: {
				open: '6:00',
				close: '21:00'
			},
			wednesday: {
				open: '6:00',
				close: '21:00'
			},
			thursday: {
				open: '6:00',
				close: '21:00'
			},
			friday: {
				open: '6:00',
				close: '21:00'
			},
			saturday: {
				open: '6:00',
				close: '21:00'
			},
			sunday: {
				open: '8:00',
				close: '19:00'
			}
		}
	};

	var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

	var mapStoreHoursToString = function (storeHours) {
		var storeHoursInString = days.map(function (day, index) {
			return (index + 1) + ';' + storeHours[day].open + '-' + storeHours[day].close;
		}).reduce(function (concatenatedStoreHours, storeHours) {
			return concatenatedStoreHours ? (concatenatedStoreHours + ';' + storeHours) : storeHours;
		});
		return storeHoursInString;
	};

	var mapStringToStoreHours = function (storeHoursInString) {
		var storeHours = {};
		storeHoursInString
			.split(';')
			.filter(function (value, index) {
				return index % 2 !== 0;
			}).map(function (openCloseHours) {
				var hours = openCloseHours.split('-');
				return {
					'open': hours[0],
					'close': hours[1]
				}
			}).forEach(function (openCloseHours, index) {
				var day = days[index];
				storeHours[day] = openCloseHours;
			});
		return storeHours;
	};


	var destructureStoreDetails = function(store) {
		var storeObj = {};
		if (store) {
			var storeDetails = store.split('+');
			try {
				var storeNameAndCityState = storeDetails[1];
				var dashCount = storeNameAndCityState.split('-').length - 1;
				if (dashCount === 1) {
					storeObj.storeId =storeDetails[0],
					storeObj.name = storeDetails[1].split('-')[0].trim(),
					storeObj.city = storeDetails[1].split('-')[1].split(',')[0].trim(),
					storeObj.state = storeDetails[1].split('-')[1].split(',')[1].trim()
					return storeObj;
				} else {
					var lastIndexOf = storeNameAndCityState.lastIndexOf(' - ');
					var name = storeNameAndCityState.substr(0, lastIndexOf);
					var cityState = storeNameAndCityState.substr(lastIndexOf + 3);

					return {
						storeId: storeDetails[0],
						name: name,
						city: cityState.split(',')[0].trim(),
						state: cityState.split(',')[1].trim()
					}
				}
			} catch(e) {
				return {
					storeId: storeDetails[0],
					name: storeDetails[1].trim(),
					city: storeDetails[3].split(',')[0].trim(),
					state: storeDetails[4]
				}
			}
		} 
	}

	/**
	 * @module StoreService
	 * @description Provides methods to get/set/remove store details in json format.
	 * @type {Object}
	 */
	var storeService = {

		/**
		 * @function GetDefaultStore
		 * @description Returns the default store details #121
		 * @return {object} Returns the default store #121
		 */
		getDefaultStore: function () {
			return defaultStore;
		},

		/**
		 * @function SetDefaultStore
		 * @description Persists default store #121
		 */
		setDefaultStore: function () {
			this.setStore(defaultStore);
		},

		/**
		 * @function SetStore
		 * @description Converts the subset of store information(json) to string format and
		 * persists in storage.
		 * @param {object} store - store to be persisted.
		 * @param {string} storageStrategy Optional parameter allows consumer to specify the storage method.
		 */
		setStore: function (store) {
			var fixedStoreId = store.storeId.replace(/^0/, '');
			var storeDetails = JSON.stringify({
				storeId: fixedStoreId,
				name: store.name,
				street: store.address && store.address.street,
				city: store.address && store.address.city,
				state: store.address && store.address.state,
				zipcode: store.address && store.address.postalCode
			});
			storeDetails = fixedStoreId + '+' + store.name + ' - ' + store.address.city + ', ' + store.address.state + '+';
			repositoryService.setValue('THD_LOCSTORE', storeDetails);
			repositoryService.setValue('THD_STRFINDERZIP', storeDetails.zipcode);
		},

		/**
		 * @function GetStore
		 * @description Reads the store details from storage, Parses to JSON.
		 * @param {string} storageStrategy Optional parameter allows consumer to specify the storage method.
		 * @return {object} Returns the store
		 */
		getStore: function () {
			try {
				var storeDetails = repositoryService.getValue('THD_LOCSTORE');
				var zipCode = repositoryService.getValue('THD_STRFINDERZIP');
				var storeHours = repositoryService.getValue('THD_STORE_HOURS');
				storeHours = storeHours && mapStringToStoreHours(storeHours);
				var storeObj = destructureStoreDetails(storeDetails);
				return {
					storeId: storeObj.storeId,
					name: storeObj.name,
					city: storeObj.city,
					state: storeObj.state,
					zipcode: zipCode,
					storeHours: storeHours
				}
			} catch (e) {
				// console.log('No store info : storeService - getStore()');
			}
		},

		/**
		 * @function getUserStore
		 * @description If HD is accessed from one of the store location, this method returns the store
		 * from where the user has accessed HD.com
		 * @return {object} Store details
		 */
		getUserStore: function () {
			if (userService.status.isUserInStore()) {
				return this.getStore();
			}
			else return undefined;
		},
		mapStoreHoursToString: mapStoreHoursToString,
		mapStringToStoreHours: mapStringToStoreHours
	}

	return storeService;
});


//////////////////
// WEBPACK FOOTER
// ./src/storeService.js
// module id = 5
// module chunks = 0